import { MapToContext } from '@utils/objectWithDefault'

export default class Pagination {
  constructor (pagination) {
    const defaultPagination = {
      pageNumber: {val: 1, type: Number},
      totalPages: {val: 25, type: Number},
      totalCount: {val: 0, type: Number},
      pageSize: {val: 25, type: Number}
    }
    MapToContext(this, defaultPagination, pagination)
  }

  setPageData ({ page, totalPages }) {
    this.pageNumber = page
    this.totalPages = totalPages
  }

  setCurrentPage (pageNumber) {
    this.pageNumber = pageNumber
  }
}
